// extracted by mini-css-extract-plugin
export var subtitle = "_d9-2";
export var title = "_d9-0";
export var titleNoWrap = "_d9-1";